import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Modal from "@insite/mobius/Modal";
import parse from "html-react-parser";
import React, { useState } from "react";

const enum fields {
    modalTitle = "modalTitle",
    modalContent = "modalContent",
    linkText = "linkText",
}

interface Props extends WidgetProps {
    fields: {
        [fields.modalTitle]: string;
        [fields.modalContent]: string;
        [fields.linkText]: string;
    };
}

const ModalLinkWithContent: React.FC<Props> = props => {
    const [modalIsVisible, setModalIsVisible] = useState(false);
    const showModal = () => {
        setModalIsVisible(true);
    };
    const hideModal = () => {
        setModalIsVisible(false);
    };
    return (
        <StyledWrapper>
            <Link onClick={showModal}>{translate(props.fields?.linkText)}</Link>
            <Modal headline={props.fields.modalTitle} handleClose={hideModal} isOpen={modalIsVisible}>
                {parse(props.fields.modalContent, parserOptions)}
            </Modal>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: ModalLinkWithContent,
    definition: {
        group: "Basic",
        displayName: "Modal Link With Content",
        fieldDefinitions: [
            {
                name: fields.modalTitle,
                displayName: "Modal Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.modalContent,
                displayName: "Modal Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
            {
                name: fields.linkText,
                displayName: "Link Text",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
